// extracted by mini-css-extract-plugin
module.exports = {"button":"SelectCompany_button__3mMAk","gray":"SelectCompany_gray__yYFcX","black":"SelectCompany_black__327sW"};